(function($) {
    $(() => {
        
        $('.js-form').parsley({
            trigger: 'change',
            successClass: 'is-success',
            errorClass: 'is-error has-error',
            classHandler(el) {
                return el.$element.closest('.form-group');
            },
            errorsWrapper: '<div class="error error-text message"></div>',
            errorTemplate: '<span></span>'
        });

        // front-form
        $('.js-contact-form').on('submit', function (e) {
            e.preventDefault();
            const $this = $(this);

            $(this)
                .find('.js-contact-btn')
                .prop('disabled', true);
            const formdata = $this.serializeArray();

            $.ajax({
                url: ajax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'contact_form',
                    datas: formdata
                },
                success(data) {
                    const result = JSON.parse(data);
                    swal({
                        title: result.title,
                        text: result.message,
                        icon: result.icon,
                        button: 'ok'
                    });
                    if (result.status == 'success') {
                        $('.js-contact-form').trigger('reset');
                    }
                }
            }).done(response => {
                $this.find('.js-contact-btn').prop('disabled', false);
            });
        });
    });
})(jQuery);
